export default __webpack_public_path__ + "static/media/info-deep-blue.d05249c3.svg";